export const production = false;
export const prodAPI = 'https://kmb.mobstars.dev';
export const devAPI = 'https://kmb.mobstars.dev';
export const chatWsBaseUrl = 'wss://kmb.mobstars.dev';
export const chatWsAutoReconnect = true;